import * as React from 'react';

const WorkOrderNotChanged: React.FC = () => {
	return (
		<>
			Work Order has been republished and changes might have occurred on Field Report.
			<br />
			Do you want to review before approving?
		</>
	);
};

export default React.memo(WorkOrderNotChanged);
